import React from 'react';
import { Box } from '@mui/material';
import { formatFloat } from '../../../../helpers';

// Expense polarity: spending MORE is bad (red), spending LESS is good (green).
// This is the inverse of the sales side, where growth is the good direction —
// so this page deliberately does not reuse the sales `ValueWithChange`.
export function deltaColor(value: number) {
    if (value > 0) return 'error.main';
    if (value < 0) return 'success.main';
    return 'text.secondary';
}

export function formatMoney(value: number) {
    return `$${formatFloat(value)}`;
}

// Signed money, e.g. "+$1,234.00" / "-$980.00". formatFloat already prints the
// minus sign, so only the plus has to be added.
export function formatSignedMoney(value: number) {
    return (value > 0 ? '+' : '') + formatMoney(value);
}

// A percentage of null means "grew from zero" — the ratio would be infinite, so
// callers render the word "nuevo" instead of a number.
export function formatPercent(value: number | null) {
    if (value === null) return 'nuevo';
    return (value > 0 ? '+' : '') + value.toFixed(1) + '%';
}

// Signed money in the delta color. Used for the Δ$ column and the delta KPI.
export function DeltaMoney({ value }: { value: number }) {
    return (
        <Box component={'span'} sx={{ color: deltaColor(value) }}>
            {formatSignedMoney(value)}
        </Box>
    );
}

// Signed percentage in the delta color. `null` renders as "nuevo" (grew from
// nothing) and `undefined`/no-baseline renders as an em dash.
export function DeltaPercent({ value }: { value: number | null | undefined }) {
    if (value === undefined) {
        return (
            <Box component={'span'} sx={{ color: 'text.disabled' }}>
                —
            </Box>
        );
    }
    return (
        <Box
            component={'span'}
            sx={{ color: value === null ? 'error.main' : deltaColor(value) }}
        >
            {formatPercent(value)}
        </Box>
    );
}
